import React from "react";
import IncidentsForm from "./IncidentsForm.tsx";

type Props = React.ComponentProps<typeof IncidentsForm>;

const IncidentsFormDirectBoss = (props: Props) => {
  return <IncidentsForm {...props} />;
};

export default IncidentsFormDirectBoss;

